<template>
  <component
    :is="checkbox ? 'label' : to ? 'router-link' : 'span'"
    class="tag"
    :class="[color, size]"
    v-bind="to ? { to } : {}"
  >
    <input
      v-if="checkbox"
      v-model="proxyChecked"
      type="checkbox"
      class="tag-cb"
      :disabled="disabled"
    />
    <slot />
  </component>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'Tag',
  props: {
    color: { type: String, default: '' },
    size: { type: String, default: '' },
    to: { type: [String, Object], default: null },
    checkbox: { type: Boolean, default: false },
    modelValue: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const proxyChecked = computed({
      get: () => props.modelValue,
      set: (v) => emit('update:modelValue', v),
    })
    return { proxyChecked }
  },
}
</script>

<style lang="scss" scoped>
.tag-cb {
  width: 14px;
  height: 14px;
  margin: 0;
  cursor: pointer;
  accent-color: var(--primary);
}

.tag-cb:disabled {
  cursor: not-allowed;
}

label.tag {
  cursor: pointer;
}

label.tag:has(.tag-cb:disabled) {
  cursor: not-allowed;
}
a.tag:hover {
  text-decoration: underline;
}
</style>
